import { createAction } from "@reduxjs/toolkit";

export const setLoading = createAction(
    "projectForms/projectForms/setLoading"
);

export const resetProjectForms = createAction(
    "projectForms/projectForms/resetProjectForms"
);

export const resetResources = createAction(
    "projectForms/projectForms/resetResources"
);

export const setFormState = createAction(
    "projectForms/projectForms/setFormState"
);

export const removeFormState = createAction(
    "projectForms/projectForms/removeFormState"
);

export const removeUserOrientationData = createAction(
    "projectForms/projectForms/removeUserOrientationData"
);

export const setFormNotesFilePermissions = createAction(
    "projectForms/projectForms/setFormNotesFilePermissions"
);

export const setSnackBarState = createAction(
    "projectForms/projectForms/setSnackBarState"
);

export const setCompanyLogoState = createAction(
    "projectForms/projectForms/setCompanyLogoState"
);

export const setResourcesGroupedByEmployer = createAction(
    "projectForms/projectForms/setResourcesGroupedByEmployer"
);

export const setFormLabels = createAction(
    "projectForms/projectForms/setFormLabels"
);

export const setOpenedItemsList = createAction(
    "projectForms/projectForms/setOpenedItemsList"
);

export const setCurrentFormState = createAction(
    "projectForms/projectForms/setCurrentFormState"
);

export const setUnsavedChanges = createAction(
    "projectForms/projectForms/setUnsavedChanges"
);

export const setHasChanges = createAction(
    "projectForms/projectForms/setHasChanges"
);

export const setFormNotesForSave = createAction(
    "projectForms/projectForms/setFormNotesForSave"
);

export const setInitialTRFormNotesAsSet = createAction(
    "projectForms/projectForms/setInitialTRFormNotesAsSet"
);

export const setWorkers = createAction(
    "projectForms/projectForms/setWorkers"
);

export const resetWorkers = createAction(
    "projectForms/projectForms/resetWorkers"
);

export const setFormTemplateChanges = createAction(
    "projectForms/projectForms/setFormTemplateChanges"
);
export const resetFormTemplateChanges = createAction(
    "projectForms/projectForms/resetFormTemplateChanges"
);

export const setImageLoadingProgress = createAction(
    "projectForms/projectForms/setImageLoadingProgress"
);

export const setCurrentlyLoadingFormId = createAction(
    "projectForms/projectForms/setCurrentlyLoadingFormId"
);

export const setIsCancelled = createAction(
    "projectForms/projectForms/setIsCancelled"
);

export const setIsFormSaving = createAction(
    "projectForms/projectForms/setIsFormSaving"
);

export const setUploadingProgressValues = createAction(
    "projectForms/projectForms/setUploadingProgressValues"
);

export const setHasMissingOrientationForms = createAction(
    "projectForms/projectForms/setHasMissingOrientationForms"
);

export const resetDownloadData = createAction(
    "projectForms/projectForms/resetDownloadData"
);

// Put an already-saved form back into the entities without going through the
// editForm thunk. Used by mass signing, which writes each form itself and needs
// the list to update per form rather than once at the end.
export const editFormLocally = createAction(
    "projectForms/projectForms/editFormLocally"
);